import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { QR } from "@/constants/testIds";

export const MONTHS = ["Januari", "Februari", "Maret", "April", "Mei", "Juni", "Juli", "Agustus", "September", "Oktober", "November", "Desember"];

export const periodLabel = (t) => {
  const m = (t.months || []).map((n) => MONTHS[n - 1]).join(", ");
  return [m, t.year].filter(Boolean).join(" ");
};

const Pick = ({ value, onChange, testid, children, className }) => (
  <Select value={value} onValueChange={onChange}>
    <SelectTrigger className={`h-10 bg-white ${className}`} data-testid={testid}><SelectValue /></SelectTrigger>
    <SelectContent>{children}</SelectContent>
  </Select>
);

export const DateFilter = ({ month, year, sort, years, onChange }) => (
  <div className="flex flex-wrap items-center gap-2">
    <span className="overline-label mr-1">Periode</span>
    <Pick value={month} onChange={(v) => onChange({ month: v })} testid={QR.monthSelect} className="w-36">
      <SelectItem value="all">Semua bulan</SelectItem>
      {MONTHS.map((m, i) => <SelectItem key={m} value={String(i + 1)}>{m}</SelectItem>)}
    </Pick>
    <Pick value={year} onChange={(v) => onChange({ year: v })} testid={QR.yearSelect} className="w-32">
      <SelectItem value="all">Semua tahun</SelectItem>
      {years.map((y) => <SelectItem key={y} value={String(y)}>{y}</SelectItem>)}
    </Pick>
    <Pick value={sort} onChange={(v) => onChange({ sort: v })} testid={QR.sortSelect} className="w-44">
      <SelectItem value="newest">Periode terbaru</SelectItem>
      <SelectItem value="oldest">Periode terlama</SelectItem>
      <SelectItem value="title">Judul A–Z</SelectItem>
    </Pick>
  </div>
);
